import home from './home'

const { combineReducers } = require("redux");

const reducer = combineReducers({
  home
});
export default reducer;
